import constants from './constants';
var warning = {
    message: "You probably forgot to use a 'Provider'. Check " + constants.quickStartUrl + " for correct usage.",
    wasLogged: false,
};
var logProviderMissingWarning = function () {
    if (!warning.wasLogged) {
        console.error(warning.message);
        warning.wasLogged = true;
    }
};
export default logProviderMissingWarning;
